import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <div class="poem">
      
      <p class="bold text-center mb-3 mt-3">* * *</p>

      
      <p class="poem-block mb-3">
        Ah, rompiĝis ĉiuj ligoj, <br/>
        Kiuj kunigis min kun proksimuloj. <br/>
        Ho, ŝiriĝis la katenoj, <br/>
        Kiuj kunvolvis mian animon.
      </p>

      
      <p class="bold text-center mb-3 mt-3">* * *</p>


      <p class="poem-block mb-3">
        Cikoriaj floroj <br/>
        Velkas antaŭ ŝtormo. <br/>
        Kial devas mi, <br/>
        Eĉ se la ŝtorm’ ne venos,
        Velki?
      </p>

      
      <p class="bold text-center mb-3 mt-3">* * *</p>


      <p class="poem-block mb-3">
        Kurba ĉerizujo <br/>
        Al ĉielo nokta <br/>
        Branĉojn aletendas. <br/>
        Inter brakoj kriplaj <br/>
        Hele lumas steloj.
      </p>

      
      <p class="bold text-center mb-3 mt-3">* * *</p>


      <p class="poem-block mb-3">
        Vi ne amas min, ho ne, <br/>
        Nokte ne alvenas. <br/>
        Kial do en tagoj <br/>
        La rigard’ hazarda <br/>
        Min bruligas svene?
      </p>

      
      <p class="bold text-center mb-3 mt-3">* * *</p>


      <p class="poem-block mb-3">
        Kastel’ malnova <br/>
        Sur la monta pinto <br/>
        Delonge forgesis <br/>
        Pri sia pasinteco. <br/>
        Nur ni memoras.
      </p>

      
      <p class="bold text-center mb-3 mt-3">* * *</p>


      <p class="poem-block mb-3">
        Tri trunketoj- <br/>
        Inda ponto <br/>
        Trans rivero monta.
      </p>

      
      <p class="bold text-center mb-3 mt-3">* * *</p>


      <p class="poem-block mb-3">
        Aŭtoj sur herbo – <br/>
        Neelteneble. <br/>
        Prefere iri <br/>
        Nudpiede sur roso… <br/>
        Ĉu ie naturo restis?
      </p>

      
      <p class="bold text-center mb-3 mt-3">* * *</p>


      <p class="poem-block mb-3">
        Kiel akvo de la rivero, <br/>
        Verda, profunda, brilanta akvo, <br/>
        Prenas onin silento. <br/>
        Vi dissolviĝas en tiu akvo, <br/>
        Vi falas ŝtone al nigra profundo, <br/>
        Senĉese, senhalte, senhelpe… <br/>
        Kiu haltos la tempon? <br/>
        Kiu savos vin de falado? <br/>
        Lirlas surface akveroj, <br/>
        Sed profundo allogas nigre.
      </p>

      
      <p class="bold text-center mb-3 mt-3">* * *</p>


      <p class="poem-block mb-3">
        Luno, granda luno sur ĉielo. <br/>
        Ĝi spegulas ĉiujn sonojn, <br/>
        Ĉiujn pensojn, ĉiujn movojn. <br/>
        Ĝi scias ĉion pri vi. <br/>
        Ĉu vi ne timas ĝin?
      </p>

      
      <p class="bold text-center mb-3 mt-3">* * *</p>


      <p class="poem-block mb-3">
        Luno, kiel spegulo, <br/>
        Transportas ĉiujn pensojn <br/>
        Malproksimen… <br/>
        Ho, fora amik’ <br/>
        Sub ciperso aŭ sub figujo, <br/>
        Ĉu vi aŭdas min?
      </p>
    </div>
    `
  )
}
const itemName = {
  esp: 'Tankaoj kaj hokku'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item;